import dev from "./dev.json";
import local from "./local.json";
import staging from "./staging.json";
// TODO: Update the following values with the correct values FOR PROD!
import prod from "./prod.json";
import { Init } from "@newrelic/browser-agent/common/config/init-types";
import { Info } from "@newrelic/browser-agent/common/config/info";

interface AuthConfig {
  clientId: string;
  domain: string;
  loginCallback: string;
  logoutCallback: string;
  responseType?: string;
  scope: string;
  audience: string;
  customClaim?: string;
  permissions: {
    manageUsers?: string;
    manageHandovers?: string;
    createMessage?: string;
    createRequest?: string;
    createHandover?: string;
    createExtract?: string;
    createCustomerExtract?: string;
  };
  refreshTokenPeriod?: string;
}

interface Config {
  apiUrl: string;
  homeUrl: string;
  reCaptchaSiteKey: string;
}
interface EnvConfig {
  newRelic?: {
    init: Init;
    info: Info;
    loader_config: object;
  };
  auth: AuthConfig;
  config: Config;
  windowRuntime?: {
    formContext: boolean;
    suggestCssSelectors: boolean;
  };
}

// Map hostnames to their respective environment configurations
const envConfigMapping = {
  "staticsite-router-dev.origindigital-dac.com.au": dev,
  "staticsite-router-staging.origindigital-pac.com.au": staging,
  "www.originenergy.com.au": prod,
  localhost: local,
};

// Determine the running environment based on the current document location
const getConfigByEnv = (): EnvConfig => {
  const currentHost = document.location.href;
  for (const [hostname, config] of Object.entries(envConfigMapping)) {
    if (currentHost.includes(hostname)) {
      return config;
    }
  }
  // Default to local if no other environment matches
  return local;
};

const envConfig = getConfigByEnv();

export default envConfig;
